export const Types = {
    GET_BREAKDOWN_REASON_PLACES: "GET_BREAKDOWN_REASON_PLACES",
    UPDATE_BREAKDOWN_REASON_PLACE: "UPDATE_BREAKDOWN_REASON_PLACE",
    DELETE_BREAKDOWN_REASON_PLACE: "DELETE_BREAKDOWN_REASON_PLACE",
    GET_PLANTS: "GET_PLANTS",
    SET_PLANTS: "SET_PLANTS",
    GET_BREAKDOWN_GROUPS: "GET_BREAKDOWN_GROUPS",
    SET_BREAKDOWN_GROUPS: "SET_BREAKDOWN_GROUPS",
    SET_BREAKDOWN_REASON_PLACE: "SET_BREAKDOWN_REASON_PLACE",
    ADD_BREAKDOWN_REASON_PLACE: "ADD_BREAKDOWN_REASON_PLACE",
    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",
    

};

export const getBreakDownReasonPlaces = (payload) => {
    return {
        type: Types.GET_BREAKDOWN_REASON_PLACES,
        payload: payload,
    };
};

export const setBreakdownReasonPlace = (payload) => {
    return {
        type: Types.SET_BREAKDOWN_REASON_PLACE,
        payload: payload,
    };
};

export const addBreakdownReasonPlace = (payload) => {
    return {
        type: Types.ADD_BREAKDOWN_REASON_PLACE,
        payload: payload,
    };
};

export const updateBreakdownReasonPlace = (payload) => {
    return {
        type: Types.UPDATE_BREAKDOWN_REASON_PLACE,
        payload: payload,
    };
};

export const deleteBreakdownReasonPlace = (payload) => {
    return {
        type: Types.DELETE_BREAKDOWN_REASON_PLACE,
        payload: payload,
    };
};

export const getPlants = () => ({
    type: Types.GET_PLANTS,
});

export const setPlants = (payload) => ({
    type: Types.SET_PLANTS,
    payload: payload,
});

export const getBreakdownGroups = () => ({
    type: Types.GET_BREAKDOWN_GROUPS,
});

export const setBreakdownGroups = (payload) => ({
    type: Types.SET_BREAKDOWN_GROUPS,
    payload: payload,
});

export const setBreakdownReasonGro = (payload) => ({
    type: Types.SET_PLANTS,
    payload: payload,
});

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});

